import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ReportObjectsBody from './ReportObjectsBody';
import useReportObjectsColumns from './model/useReportObjectsColumns';
import type { ReportObjectsTableProps } from '../types';

const ReportObjectsTable = ({ objectsList, onShowSpecification }: ReportObjectsTableProps) => {
    const { t } = useTranslation(['Objects']);
    const { showMaterials, showServices } = useReportObjectsColumns();

    return (
        <div className="crm-table-wrap">
            <Table className="ObjectRepTable table-hover">
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">{t('fields.name')}</td>
                        <td className="head-date">{t('fields.date')}</td>
                        {showMaterials ? (
                            <td className="text-end head-materials">{t('fields.materials')}</td>
                        ) : null}
                        {showServices ? (
                            <td className="text-end head-services">{t('fields.services')}</td>
                        ) : null}
                        <td className="text-end head-income">{t('fields.income')}</td>
                        <td className="head-action">{t('fields.action')}</td>
                    </tr>
                </thead>
                <ReportObjectsBody
                    objectsList={objectsList}
                    onShowSpecification={onShowSpecification}
                    showMaterials={showMaterials}
                    showServices={showServices}
                />
            </Table>
        </div>
    );
};

export default ReportObjectsTable;
